import React from 'react';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import GridList from './GridList';
import PopupCreateEditTask from '../PopupCreateEditTask/PopupCreateEditTask';
import PopupCreateEditGeneralNote from '../PopupCreateEditGeneralNote/PopupCreateEditGeneralNote';
import Empty from '../../../Empty';
import CommonGridSpinner from '../../../CommonGridSpinner';
import Unit from '../../../Unit';
import {useTasksGridContext} from '../../../../contexts/TasksGridContext';
import {useNotesGridContext} from '../../../../contexts/NotesGridContext';
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import {taskTypeIDs} from '../../../../constants/taskTypes';
import styles from './styles.module.scss';
import {useGlobalContext} from "../../../../contexts/GlobalContext";
import themeStyles from "../../../../styles/theme.module.scss";

const Grid = () => {
  const {
    createVisitTask,
    createGeneralTask,
    resetTaskDetails,
    loadingTasksList,
  } = useTasksGridContext();
  const {
    createNote,
    resetNoteDetails,
    loadingNotesList
  } = useNotesGridContext();
  const {list, updateList, disabled, formik} = useTaskAndNotesGridContext();

  const intl = useIntl();
  const prefix = 'tab-order-inspections-tasks';
  const tasksGridHeaders = [
    '#',
    intl.formatMessage({id: `${prefix}-grid-header-createDate`, defaultMessage: 'Create date'}),
    intl.formatMessage({id: `${prefix}-grid-header-taskType`, defaultMessage: 'Task type'}),
    intl.formatMessage({id: `${prefix}-grid-header-status`, defaultMessage: 'Status'}),
    intl.formatMessage({id: `${prefix}-grid-header-details`, defaultMessage: 'Details'}),
    intl.formatMessage({id: `${prefix}-grid-header-dueDate`, defaultMessage: 'Due date'}),
    intl.formatMessage({id: `${prefix}-grid-header-createUser`, defaultMessage: 'Create user'}),
    intl.formatMessage({id: `${prefix}-grid-header-responsibleUser`, defaultMessage: 'Responsible user'}),
    '',
  ];

  const mapTasksHeaders = (text, index) => {
    return (
      <div className={styles.headerCell} key={index}>
        {text}
      </div>
    );
  };

  const handleCreateTask = taskTypeID => async () => {
    if (taskTypeID === taskTypeIDs.visit) {
      await createVisitTask(
        formik.values.responsibleUserID,
        formik.values.taskStatusID,
        formik.values.taskDueDate,
        formik.values.notes,
        formik.values.visitContactName,
        formik.values.visitContactPhone,
      )
    } else {
      createGeneralTask(
        formik.values.responsibleUserID,
        formik.values.taskStatusID,
        formik.values.taskDueDate,
        formik.values.taskDescription,
      )
    }
    formik.resetForm();
    await updateList();
  };

  const handleCreateGeneralNote = async () => {
    await createNote(
      formik.values.generalNoteStatusTypeID,
      formik.values.generalNoteDueDate,
      formik.values.generalNoteResponsibleUserID,
      formik.values.generalNoteFreeText,
    );
    formik.resetForm();
    await updateList();
  };
  const {isGlassTheme} = useGlobalContext();

  return (
    <Unit
      text={intl.formatMessage({id: `${prefix}-header`, defaultMessage: 'Tasks'})}
      icon={'/media/common/Tasks_secondary.svg'}
      customClassnames={'my-4'}
    >
      <div className={styles.tasksCreateButtons}>
        <PopupCreateEditTask
          taskID={-1}
          taskType={taskTypeIDs.visit}
          onEdit={handleCreateTask(taskTypeIDs.visit)}
          onOpen={resetTaskDetails}
          disabled={disabled}
        />
        <PopupCreateEditTask
          taskID={-1}
          taskType={taskTypeIDs.general}
          onEdit={handleCreateTask(taskTypeIDs.general)}
          onOpen={resetTaskDetails}
          disabled={disabled}
        />
        <PopupCreateEditGeneralNote
          generalNoteID={-1}
          onEdit={handleCreateGeneralNote}
          onOpen={resetNoteDetails}
          disabled={disabled}
        />
      </div>
      <div className={classnames(styles.tasksHeader,
        {'pr-6': list.length > 5},
        isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
        isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
      )}>
        {tasksGridHeaders.map(mapTasksHeaders)}
      </div>
      <div>
        {(loadingTasksList || loadingNotesList) && <CommonGridSpinner/>}
        {list.length === 0 && !(loadingTasksList || loadingNotesList)
          ? <Empty message={intl.formatMessage({id: `${prefix}-grid-no-tasks`, defaultMessage: 'No tasks'})} customContainerClassname={'py-6'}/>
          : <GridList/>
        }
      </div>
    </Unit>
  );
};

export default Grid;
